import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { TdMediaService } from '@covalent/core';

import { LoginService, NotasService } from '../../services/';

import { HojaDeConsulta, Nota } from '../../models';

@Component({
  selector: 'qs-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.scss'],
  providers: [NotasService],
})
export class ConsultaComponent implements AfterViewInit {

  private consulta: HojaDeConsulta;

  public idPaciente: string;
  public title: string;
  public notas: Nota[];

  constructor(
    private _route: ActivatedRoute,
    private _titleService: Title,
    public media: TdMediaService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _notasService: NotasService) {
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.consulta = this._loginService.consulta;
    let title: string = this.consulta.nombre + ' ';
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    title += this.consulta.presente ? '' : '(Ausente)';
    this.title = title;
    this._titleService.setTitle(this.title);
    this._notasService.obtenerNotas(this.idPaciente, this._loginService.profesional.Dni, false).subscribe((res: any) => {
      this.notas = res.respuesta.notas || [];
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo notas.', 'OK', 6000);
    });
    this._changeDetectorRef.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/consulta.component.ts